import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axiosInsatnace, { chatStatus, contactView, getProfileById } from '../../../asiosConfig';
import sendInterestIcons from "../../../images/sendInterestIcon.png";
import chatWhiteIcon from "../../../images/chatWhiteIcon.png";
import diclineWhiteIcon from "../../../images/diclineWhiteIcon.png";
import callWhiteIcon from "../../../images/callWhiteIcon.png";
import acceptIcon from "../../../images/acceptIcon.png";
import popup from "../../../images/popup_design.png";
import TimeDateIcon from "../../../images/TimeDateIcon.png";
import shortlistIcon from "../../../images/shortlistIcon.png";
import SendInterest from "../../../images/SendInterest.png";
import IgnoreIcon from "../../../images/IgnoreIcon.png";
import ContactIcon from "../../../images/ContactIcon.png";
import AcceptInterestIcon from "../../../images/AcceptInterestIcon.png";
import BookMarkRemoveIcon from "../../../images/BookmarkIcon.png";
import DeclinedInterestIcon from "../../../images/DelinedIcon.png";
import sendRemidIcon from "../../../images/SendReminderIcon.png";
import ChatIcon from "../../../images/ChatIcon.png";
import RemoveIgnoreIcon from "../../../images/RemoveIgnoreIcon.png";
import { CircularProgress, Dialog, DialogTitle, DialogContent, Typography, Box, IconButton, DialogActions, Divider } from '@mui/material';
import { Call, Chat, Check, Close, NotificationsActive, RemoveCircleSharp, Send, Star } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../services/firebaseConfig';
import MessengerModal from '../../MessengerModel';

const isEmpty = (array) => Array.isArray(array) && array.length === 0;

export const ActionButton = ({ profileData }) => {
    const { send = [], received = [], ignored = [], bookmarked = [], user_info } = profileData?.search || {};
    const recipientId = user_info?.register_id;
    const [contactInfo, setContactInfo] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(null);
    const [updatedData, setUpdatedData] = useState(profileData);
    const navigate = useNavigate();
    const username = localStorage.getItem('username');
    const [openMessengerModal, setOpenMessengerModal] = useState(false);

    const fetchUpdatedData = async () => {
        try {
            // Assuming you have an API endpoint to fetch the updated profile data
            const response = await getProfileById({ user_id: recipientId });
            setUpdatedData(response.data);  // Update the state with new data
        } catch (error) {
            toast.error('Failed to fetch updated data');
        }
    };

    const handleAction = async (url, data, label) => {
        setLoading(label); // set loading state to the current action label
        try {
            const response = await axiosInsatnace.post(url, data);
            if (response.status === 200 || response.status === 201) {
                logEvent(analytics, 'user_action', {
                    user_id: localStorage.getItem('user'),
                    profile_id: data.user_id,
                    action: data.response_type,
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                })
                toast.success(response.data.message);
                await fetchUpdatedData();
            } else {
                toast.error(response.data.message);
            }

        } catch (error) {
            toast.error(error.response?.data?.message);
        } finally {
            setLoading(null); // reset loading state after response
        }
    };
    const handleReminder = async (url, data, label) => {
        setLoading(label); // set loading state to the current action label
        try {
            const response = await axiosInsatnace.post(url, data);
            if (response.status === 200 || response.status === 201) {

                logEvent(analytics, 'sendReminder', {
                    user_id: localStorage.getItem('user'),
                    profile_id: data.user_id,
                    action: data.response_type,
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                })
                toast.success(response.data.message);
                await fetchUpdatedData();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);
        } finally {
            setLoading(null); // reset loading state after response
        }
    };

    const handleContactClick = async () => {
        setLoading("Contact");
        try {
            const response = await contactView({ profile_id: recipientId });
            if (response.status === 200 || response.status === 201) {

                logEvent(analytics, 'view_contact', {
                    user_id: localStorage.getItem('user'),
                    profile_id: recipientId,
                    action: 'contact_view',
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                });
                setContactInfo(response.data.data);
                setOpenModal(true);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to retrieve contact info');
        } finally {
            setLoading(null);
        }
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const startChat = async (recipientId, profile) => {

        // const currentUserId = username;
        // const chatId = [currentUserId, recipientId].sort().join('_');
        // try {
        //     const response = await chatStatus({profile_id: profile.register_id });

        //     const { SUCCESS, ERROR, chatReason, chatAllowed } = response.data;
        //     if (SUCCESS === 1 && chatAllowed === "true") {
        //         navigate(`/chat`, { state: { chatId, recipientId, profile } });

        //     } else {
        //         toast.error(ERROR || chatReason);
        //     }
        // } catch (error) {
        //     toast.error("Error starting chat:", error);
        // }
        setOpenMessengerModal(true);

    };

    const getAction = () => {
        const { send = [], received = [], ignored = [], bookmarked = [], user_info } = updatedData?.search || {};

        if (!isEmpty(ignored)) {
            return [
                { icon: RemoveIgnoreIcon, label: 'Ignore', onClick: () => handleAction('profile-activity', { user_id: ignored.member_id, response_type: 'remove_ignore' }, 'Remove') },
                { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
            ];
        } else
            if (!isEmpty(bookmarked) && !send && !received) {
                return [
                    { icon: SendInterest, label: 'Send Interest', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'interest' }) },
                    { icon: BookMarkRemoveIcon, label: 'Remove', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'remove_bookmark' }) },
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (!isEmpty(bookmarked) && send?.accept === 0 && send?.reject === 0) {

                return [
                    { icon: BookMarkRemoveIcon, label: 'Remove', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'remove_bookmark' }) },
                    { icon: sendRemidIcon, label: 'Send Reminder', onClick: () => handleReminder('profile-activity', { user_id: recipientId, response_type: 'send_reminder' }) },
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (!isEmpty(bookmarked) && send?.accept === 1 && send?.reject === 0) {
                return [
                    { icon: BookMarkRemoveIcon, label: 'Remove', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'remove_bookmark' }) },
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (!isEmpty(bookmarked) && received?.accept === 0 && received?.reject === 0) {
                return [
                    { icon: BookMarkRemoveIcon, label: 'Remove', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'remove_bookmark' }) },
                    { icon: AcceptInterestIcon, label: 'Accept Interest', onClick: () => handleAction('profile-activity', { user_id: received.sender, response_type: 'accept' }) },
                    { icon: DeclinedInterestIcon, label: 'Decline Interest', onClick: () => handleAction('profile-activity', { user_id: received.sender, response_type: 'reject' }) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (!isEmpty(bookmarked) && received?.accept === 1 && received?.reject === 0) {
                return [
                    { icon: BookMarkRemoveIcon, label: 'Remove', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'remove_bookmark' }) },
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (!send && !received) {
                return [
                    { icon: SendInterest, label: 'Send Interest', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'interest' }, 'Send Interest') },
                    { icon: shortlistIcon, label: 'Shortlisted', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'bookmark' }, 'Shortlisted') },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (isEmpty(bookmarked) && send?.accept === 0 && send?.reject === 0) {
                return [
                    { icon: sendRemidIcon, label: 'Send Reminder', onClick: () => handleReminder('profile-activity', { user_id: recipientId, response_type: 'send_reminder' }) },
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: DeclinedInterestIcon, label: 'Decline Interest', onClick: () => handleAction('profile-activity', { user_id: send.recipient, response_type: 'reject' }, 'Cancle Interest') },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (isEmpty(bookmarked) && send?.accept === 1 && send?.reject === 0) {
                return [
                    // { icon: ChatIcon, label: 'Chat', onClick: () => startChat(recipientId) },
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (isEmpty(bookmarked) && send?.accept === 0 && send?.reject === 1) {
                return [
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: IgnoreIcon, label: 'Ignore', onClick: () => handleAction('profile-activity', { user_id: send.recipient, response_type: 'ignored' }) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (isEmpty(bookmarked) && received?.accept === 0 && received?.reject === 0) {
                return [
                    { icon: AcceptInterestIcon, label: 'Accept Interest', onClick: () => handleAction('profile-activity', { user_id: received.sender, response_type: 'accept' }, 'Accept Interest') },
                    { icon: DeclinedInterestIcon, label: 'Decline Interest', onClick: () => handleAction('profile-activity', { user_id: received.sender, response_type: 'reject' }, 'Decline Interest') },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (isEmpty(bookmarked) && received?.accept === 1 && received?.reject === 0) {
                return [
                    { icon: IgnoreIcon, label: 'Ignore', onClick: () => handleAction('profile-activity', { user_id: received.sender, response_type: 'ignored' }) },
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (isEmpty(bookmarked) && received?.reject === 1) {
                return [
                    { icon: AcceptInterestIcon, label: 'Accept Interest', onClick: () => handleAction('profile-activity', { user_id: received.sender, response_type: 'accept' }) },
                    { icon: IgnoreIcon, label: 'Ignore', onClick: () => handleAction('profile-activity', { user_id: received.sender, response_type: 'ignored' }) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            } else if (isEmpty(bookmarked) && (send?.accept === 1 || received?.accept === 1)) {
                return [
                    { icon: ChatIcon, label: 'Chat', onClick: () => startChat(user_info.username, user_info) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                    { icon: DeclinedInterestIcon, label: 'Decline Interest', onClick: () => handleAction('profile-activity', { user_id: send.recipient, response_type: 'reject' }, 'Decline Interest') },
                ];
            } else {
                return [
                    { icon: SendInterest, label: 'Send Interest', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'interest' }, 'Send Interest') },
                    { icon: shortlistIcon, label: 'Shortlisted', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'bookmark' }, 'Shortlisted') },
                    { icon: IgnoreIcon, label: 'Ignore', onClick: () => handleAction('profile-activity', { user_id: recipientId, response_type: 'ignored' }) },
                    { icon: ContactIcon, label: 'Contact', onClick: handleContactClick },
                ];
            }
    };
    const renderButtons = () => {
        const actions = getAction();

        return actions.map(({ icon, label, onClick }) => (
            <Box
                key={label}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px',
                    cursor: 'pointer',
                    textAlign: 'center',
                }}
                onClick={onClick}
            >
                {loading === label ? (
                    <CircularProgress size={30} />
                ) : (
                    <>
                        {typeof icon === 'string' ? (
                            <Box
                                component="img"
                                src={icon}
                                alt={label}
                                sx={{ width: 30, marginBottom: 1 }}
                            />
                        ) : (
                            icon
                        )}
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: '14px',
                                fontWeight: '500',
                                color: 'inherit',
                                textAlign: 'center',
                                paddingTop: '5px',
                            }}
                        >
                            {label}
                        </Typography>
                    </>
                )}
            </Box>
        ));
    };
    return (
        <>
            {renderButtons()}

            {/* MUI Modal for Contact Information */}
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="contact-dialog-title"
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiPaper-root': {
                        width: '500px',
                        height: '400px'
                    }
                }}
            >
                <DialogTitle id="contact-dialog-title" align="center">
                    <Typography variant="h5">
                        {contactInfo?.text || ''}
                    </Typography>
                    <Divider variant="middle" sx={{ mb: 2 }} />
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                        <div className="viewCall">
                            <img src={user_info.photo} style={{ width: '60px', height: '60px', borderRadius: '50%' }} alt="Profile" />
                            <p className="mt-2">{user_info?.username}</p>
                            {contactInfo ? (
                                <>
                                    <Typography variant="body1">Email: {contactInfo.email}</Typography>
                                    <Typography variant="body1">Phone: {contactInfo.mobileNumber}</Typography>
                                </>
                            ) : (
                                <Typography variant="body2">Loading...</Typography>
                            )}
                        </div>
                    </Box>
                </DialogContent>
                <div className="d-grid p-3">
                    <a href="/upgrade" target="_blank" className="btn btn-danger vplan">View Plan</a>
                </div>
            </Dialog>
            <MessengerModal
                open={openMessengerModal}
                onClose={() => setOpenMessengerModal(false)}
            />
        </>
    );
};
